import { RefObject, useEffect } from 'react';
import { useRafState } from 'react-use';

export interface State {
  clientX: number;
  clientY: number;
}

/**
 * react-use에서 제공하는 useMouse에서 clientX, clientY 값을 반환하지 않아
 * 당장 필요한 clientX, clientY 값을 반환하는 커스텀 훅을 작성합니다.
 * @see : https://github.com/streamich/react-use/blob/master/src/useMouse.ts
 *
 * @param ref
 */
const useMouseClientPosition = (ref: RefObject<Element>): State => {
  const [state, setState] = useRafState<State>({
    clientX: 0,
    clientY: 0,
  });

  useEffect(() => {
    const moveHandler = (event: MouseEvent) => {
      if (ref && ref.current) {
        setState({
          clientX: event.clientX,
          clientY: event.clientY,
        });
      }
    };

    document.addEventListener('mousemove', moveHandler);

    return () => {
      document.removeEventListener('mousemove', moveHandler);
    };
  }, [ref, setState]);

  return state;
};

export default useMouseClientPosition;
